export const isProduction = process.env.APP_ENV === 'prod';
export const posthogProjectApiKey = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_API_KEY || '';
